<template>
  <div class="drawer_container">
    <img style="width: 30px;height: 100px;cursor: pointer" :class="drawer?'openBtn':'closeBtn'"
       @touchstart="changeRightDrawer"  @click="changeRightDrawer"
         :src="drawer?dialogLeft:dialogRight"/>
    <el-drawer
      title="设置"
      :visible.sync="drawer"
      :direction="direction"
      size="100%"
      :with-header="false"
      :wrapperClosable="false"
      :modal="false">
      <div style="height: 100%;width: 100%;padding: calc(8vh) 20px 20px 20px;">
        <div v-if="drawerType === 'grid'">
          <div class="drawer_wrap">
            <el-form label-width="80px">
              <el-form-item label="是否显示网格" label-width="100px">
                <el-switch
                  v-model="showGrid" @change="changeGrid"
                  active-color="#13ce66"
                  inactive-color="#ff4949">
                </el-switch>
              </el-form-item>
              <div v-show="showGrid">
                <el-form-item label="网格类型">
                  <el-radio-group v-model="grid.type" @change="changeGridType">
                    <el-radio v-for="item in gridTypeList" :label="item.value" :key="item.value">
                      <span>{{ item.label }}</span>
                    </el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="网格大小">
                  <el-slider v-model="grid.size" :min="0" :max="30" @change="changeGrid"></el-slider>
                </el-form-item>
                <el-form-item label="网格颜色">
                  <el-color-picker v-model="grid.args.color" @change="changeGrid"/>
                </el-form-item>
                <el-form-item label="网格线宽度" label-width="90px">
                  <el-slider v-model="grid.args.thickness" :min="0" :max="20" @change="changeGrid"></el-slider>
                </el-form-item>
              </div>
            </el-form>
          </div>
        </div>
        <div v-if="drawerType === 'node'">
          <div class="drawer_title">节点设置</div>
          <div class="drawer_wrap">
            <el-form label-width="80px">
              <el-form-item label="节点文本">
                <el-input v-model="drawerNode.nodeText" @change="changeNodeText"></el-input>
              </el-form-item>
              <el-form-item label="节点背景">
                <el-color-picker v-model="drawerNode.fill" :show-alpha="true"  @change="changeFill"/>
              </el-form-item>
              <el-form-item label="字体大小">
                <el-slider v-model="drawerNode.fontSize" :min="10" :max="20" @change="changefontSize"></el-slider>
              </el-form-item>
              <el-form-item label="字体颜色">
                <div style="display: flex;">
                  <el-color-picker v-model="drawerNode.fontFill" @change="changeFontFill"/>
                  <el-checkbox-button 
                    style="margin-left: 20px;" 
                    v-model="drawerNode.isBold"
                    @change="changeBold" 
                    size="mini">B</el-checkbox-button>
                </div>
              </el-form-item>
              <el-form-item label="边框宽度">
                <el-slider v-model="drawerNode.strokeWidth" :min="0" :max="10" @change="changeStrokeWidth"></el-slider>
              </el-form-item>
              <el-form-item label="边框颜色">
                <el-color-picker v-model="drawerNode.stroke" :show-alpha="true"  @change="changeStroke"/>
              </el-form-item>
              <el-form-item label="功能">
                <el-button type="primary" @touchstart="toTopZIndex"  @click="toTopZIndex">置顶</el-button>
                <el-button type="error" class="margin-left-10" @touchstart="deleteNode" @click="deleteNode">删除</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <div v-if="drawerType === 'image'">
          <div class="drawer_title">自定义图片设置</div>
          <div class="drawer_wrap">
            <el-form label-width="80px">
              <el-form-item label="节点文本">
                <el-input v-model="drawerNode.nodeText" @change="changeNodeText"></el-input>
              </el-form-item>
              <el-form-item label="字体大小">
                <el-slider v-model="drawerNode.fontSize" :min="10" :max="20" @change="changefontSize"></el-slider>
              </el-form-item>
              <el-form-item label="字体颜色">
                <div style="display: flex;">
                  <el-color-picker v-model="drawerNode.fontFill" @change="changeFontFill"/>
                  <el-checkbox-button 
                    style="margin-left: 20px;" 
                    v-model="drawerNode.isBold"
                    @change="changeBold" 
                    size="mini">B</el-checkbox-button>
                </div>
              </el-form-item>
              <el-form-item label="功能">
                <el-button type="primary" @touchstart="toTopZIndex" @click="toTopZIndex">置顶</el-button>
                <el-button type="error" class="margin-left-10" @touchstart="deleteNode" @click="deleteNode">删除</el-button>
              </el-form-item>
              <el-form-item label="关联设备">
                <el-select v-model="drawerNode.deviceId"  clearable :disabled="!!drawerNode.spaceId" placeholder="请选择" @change="changeDeviceId">
                  <el-option
                    v-for="item in deviceList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="关联空间">
                <el-cascader
                  :options="spaceTree"
                  @change="changeSpace"
                  :disabled="!!drawerNode.deviceId"
                  change-on-select="true"
                  clearable
                  collapse-tags
                  filterable
                  :props="{
                    value: 'id',
                    label: 'title',
                    children: 'children'
                  }"
                  placeholder="请选择"
                  style="padding-bottom: 5px;"
                  v-model="drawerNode.spaceId">
                </el-cascader>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <div v-if="drawerType === 'edge'">
          <div class="drawer_title">线条设置</div>
          <div class="drawer_wrap">
            <el-form label-width="80px">
              <el-form-item label="线条文本">
                <el-input v-model="drawerEdge.EdgeText" @change="changeEdgeText"></el-input>
              </el-form-item>
              <el-form-item label="线条宽度">
                <el-slider v-model="drawerEdge.edgeWidth" :min="1" :max="10" @change="changeEdgeWidth"></el-slider>
              </el-form-item>
              <el-form-item label="线条颜色">
                <el-color-picker v-model="drawerEdge.edgeColor" @change="changeEdgeColor"/>
              </el-form-item>
              <el-form-item label="功能">
                <el-button type="primary" @touchstart="toTopZIndex" @click="toTopZIndex">置顶</el-button>
                <el-button type="error" class="margin-left-10" @touchstart="deleteNode" @click="deleteNode">删除</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import {getUserListBySpaceIdAndStatus} from "@/network/device-info";
import {getSpaceTreeData} from '@/network/space-info';

export default {
  name: 'RightDrawer',
  data() {
    return {
      gridTypeList: [
        {
          label: '四边网格',
          value: 'mesh'
        },
        {
          label: '点状网格',
          value: 'dot'
        }
      ],
      deviceList: [
        {
        name: '设备1',
        id: '1636255320236322816',
      },
      {
        name: '设备2',
        id: '1640536245972123648',
      },
      {
        name: '设备3',
        id: '1640558203208077312',
      }
      ],
      showGrid: true,
      drawerNode: {
        fill: '',
        nodeText: '',
        fontSize: null,
        fontFill: '',
        strokeWidth: null,
        stroke: '',
        deviceId: '',
        spaceId: '',
        isBold: false
      },
      drawerEdge: {
        EdgeText: '',
        edgeWidth: null,
        edgeColor: ''
      },
      direction: 'rtl',
      // 弹窗面板是否展开
      dialogRight: require('../../../assets/images/antVx6/dialogRight.png'),
      dialogLeft: require('../../../assets/images/antVx6/dialogLeft.png')
    };
  },
  props: {
    drawerType: {
      type: String
    },
    selectCell: {
      // eslint-disable-next-line vue/require-prop-type-constructor
      type: String | Object
    },
    graph: {
      // eslint-disable-next-line vue/require-prop-type-constructor
      type: String | Object
    },
    grid: {
      type: Object
    },
    drawer: {
      type: Boolean
    },
    spaceId: {
      type: String
    }
  },
  mounted() {
    console.log(this.spaceId)
    if (this.spaceId) {
      this.getSpaceInfo(this.spaceId)
    }
    this.getSpaceTreeData();
    // 添加键盘事件监听
    window.addEventListener('keydown', this.handleKeyDown);
  },
  beforeDestroy() {
    // 移除键盘事件监听
    window.removeEventListener('keydown', this.handleKeyDown);
  },
  watch: {
    selectCell: {
      handler(val) {
        if (val) {
          console.log(val.isNode(), 'isNode')
          if (val.isNode()) { //节点
            // 是否为自定义图片节点
            if (val.store.data.attrs.image !== undefined) {
              this.drawerNode.nodeText = val.store.data.attrs.label.text;
              this.drawerNode.fontFill = val.store.data.attrs.label.fill;
              this.drawerNode.fontSize = Number(val.store.data.attrs.label.fontSize);
              this.drawerNode.deviceId = val.data && val.data.deviceId ? val.data.deviceId : '';
              this.drawerNode.spaceId = val.data && val.data.spaceId ? val.data.spaceId : '';
              // 获取加粗状态
              this.drawerNode.isBold = val.store.data.attrs.label.fontWeight === 'bold' || 
                                              val.store.data.attrs.label.style?.fontWeight === 'bold';
              // 根据是否有关联设备或空间来设置鼠标样式
              if ((val.data && val.data.deviceId) || (val.data && val.data.spaceId)) {
                this.selectCell.attr('image/style/cursor', 'pointer');
              } else {
                this.selectCell.attr('image/style/cursor', 'default');
              }
            } else {
              // 为内置节点
              this.drawerNode.fill = val.store.data.attrs.body.fill
              this.drawerNode.nodeText = val.store.data.attrs.label.text
              this.drawerNode.fontFill = val.store.data.attrs.label.fill
              this.drawerNode.fontSize = Number(val.store.data.attrs.label.fontSize)
              this.drawerNode.strokeWidth = Number(val.store.data.attrs.body.strokeWidth)
              this.drawerNode.stroke = val.store.data.attrs.body.stroke
              // 获取加粗状态
              this.drawerNode.isBold = val.store.data.attrs.label.fontWeight === 'bold' || 
                                              val.store.data.attrs.label.style?.fontWeight === 'bold';
              // 根据是否有关联设备或空间来设置鼠标样式
              // if ((val.data && val.data.deviceId) || (val.data && val.data.spaceId)) {
              //   this.selectCell.attr('image/style/cursor', 'pointer');
              // } else {
              //   this.selectCell.attr('image/style/cursor', 'default');
              // }
            }
          } else { //边
            this.drawerEdge.EdgeText = val.store.data.labels ? val.store.data.labels[0].text : ''
            this.drawerEdge.edgeWidth = Number(val.store.data.attrs.line.strokeWidth)
            this.drawerEdge.edgeColor = val.store.data.attrs.line.stroke
          }
        }
      },
      immediate: true,
      deep: false
    },
    // 监听spaceId
    spaceId: {
      handler(val) {
        this.getSpaceInfo(val)
      },
      immediate: true,
      deep: false
    }
  },
  methods: {
    getSpaceInfo(id) {
      if (id === '') {
        return
      }
      console.log(id)
      getUserListBySpaceIdAndStatus(id).then(res => {
        if (res.data) {
          this.deviceList = res.data
        }
      })
    },
    changeGridType(e) {
      this.grid.type = e
      this.changeGrid()
    },
    // 网格设置
    changeGrid() {
      this.showGrid ? this.graph.showGrid() : this.graph.hideGrid()
      this.graph.drawGrid({
        ...this.grid
      })
    },
    // 节点设置
    changeStrokeWidth(val) {
      this.selectCell.attr('body/strokeWidth', val)
    },
    // 改变字体大小
    changefontSize(val) {
      this.selectCell.attr('label/style/fontSize', val)
      this.selectCell.attr('label/fontSize', val)
    },
    // 改变节点文本
    changeNodeText() {
      console.log(this.selectCell, 'this.selectCell')
      this.selectCell.attr('label/text', this.drawerNode.nodeText)
    },
    // 改变变宽颜色
    changeStroke(val) {
      this.drawerNode.stroke = val
      this.selectCell.attr('body/stroke', this.drawerNode.stroke)
    },
    // 改变字体颜色
    changeFontFill(val) {
      this.drawerNode.fontFill = val
      this.selectCell.attr('label/fill', this.drawerNode.fontFill)
      this.selectCell.attr('foreignObject/style/color',  this.drawerNode.fontFill);
    },
    // 改变节点背景
    changeFill(val) {
      this.drawerNode.fill = val
      this.selectCell.attr('body/fill', val)
    },
    // 改变线条文本
    changeEdgeText() {
      this.selectCell.setLabels([this.drawerEdge.EdgeText])
    },
    // 改变线条宽度
    changeEdgeWidth(val) {
      this.drawerEdge.edgeWidth = val
      this.selectCell.attr('line/strokeWidth', this.drawerEdge.edgeWidth)
      this.$emit('updateEdgeWidth', val)
    },
    // 改变线条颜色
    changeEdgeColor(val) {
      this.drawerEdge.stroke = val
      this.selectCell.attr('line/stroke', this.drawerEdge.stroke)
      // 发送事件到父组件更新默认线条颜色
      this.$emit('updateEdgeColor', val)
    },
    // 置顶
    toTopZIndex() {
      this.selectCell.toFront()
    },
    // 删除
    deleteNode() {
      this.$emit('deleteNode')
    },
    // 改变状态
    changeRightDrawer() {
      this.$emit('changeRightDrawer')
    },
    // 改变关联设备
    changeDeviceId(val) {
      this.selectCell.updateData({ 
        deviceId: val || '',
        spaceId: val ? '' : this.drawerNode.spaceId
      });
      this.drawerNode.spaceId = val ? '' : this.drawerNode.spaceId;
      // 添加鼠标样式
      this.selectCell.attr('image/style/cursor', val ? 'pointer' : 'default');
      console.log(this.selectCell);
    },
    // 改变关联空间
    changeSpace(val) {
      console.log(val, 'val');
      if (!val || (Array.isArray(val) && val.length === 0)) {
        this.selectCell.updateData({ 
          spaceId: '',
          deviceId: this.drawerNode.deviceId
        });
        this.drawerNode.spaceId = '';
        // 根据是否有关联设备来决定鼠标样式
        this.selectCell.attr('image/style/cursor', this.drawerNode.deviceId ? 'pointer' : 'default');
      console.log(this.selectCell);
        return;
      }

      this.selectCell.updateData({ 
        spaceId: val,
        deviceId: ''
      });
      this.drawerNode.deviceId = '';
      // 添加鼠标手势样式
      this.selectCell.attr('image/style/cursor', 'pointer');
      console.log(this.selectCell, 'selectCellselectCellselectCell');
    },
    getSpaceTreeData() {
      getSpaceTreeData().then(res => {
        if (res.code === 0) {
          // 将树转换成需要的格式
          this.spaceTree = res.data;
        }
      });
    },
    // 添加键盘事件处理方法
    handleKeyDown(event) {
        // 只有在有选中节点且是节点类型时才处理键盘事件
        if (!this.selectCell || !this.selectCell.isNode()) return;

        // 获取当前位置
        const currentPosition = this.selectCell.position();
        const step = event.shiftKey ? 10 : 1; // 按住 shift 时移动步长为10，否则为1

        switch (event.key) {
            case 'ArrowUp':
                event.preventDefault();
                this.selectCell.position(currentPosition.x, currentPosition.y - step);
                break;
            case 'ArrowDown':
                event.preventDefault();
                this.selectCell.position(currentPosition.x, currentPosition.y + step);
                break;
            case 'ArrowLeft':
                event.preventDefault();
                this.selectCell.position(currentPosition.x - step, currentPosition.y);
                break;
            case 'ArrowRight':
                event.preventDefault();
                this.selectCell.position(currentPosition.x + step, currentPosition.y);
                break;
        }

        // 如果节点移动了，更新连接的边
        if (this.graph) {
            this.graph.trigger('node:moved', { node: this.selectCell });
        }
    },
    // 添加处理加粗的方法
    changeBold(val) {
        if (!this.selectCell) return;
        
        console.log('设置文本加粗:', val);
        this.drawerNode.isBold = val;
        
        // 更新文本加粗状态
        if (this.selectCell.store.data.attrs.image !== undefined) {
            // 自定义图片节点
            this.selectCell.attr({
                label: {
                    fontWeight: val ? 'bold' : 'normal',
                    style: {
                        fontWeight: val ? 'bold' : 'normal'
                    }
                }
            });
        } else {
            // 普通节点
            this.selectCell.attr({
                label: {
                    fontWeight: val ? 'bold' : 'normal',
                    style: {
                        fontWeight: val ? 'bold' : 'normal'
                    }
                },
                text: {
                    fontWeight: val ? 'bold' : 'normal',
                    style: {
                        fontWeight: val ? 'bold' : 'normal'
                    }
                }
            });
        }
        
        // 强制更新视图
        if (this.graph) {
            this.graph.trigger('node:change', { node: this.selectCell });
        }
    }
  },
};
</script>

<style lang="less" scoped>
.drawer_container {
  .drawer_title {
    border-bottom: 1px solid #0B3B66;
    box-sizing: border-box;
    padding: 14px 16px;
    color: #FFFFFF;
    font-size: 16px;
  }

  .drawer_wrap {
    box-sizing: border-box;
    padding: 20px 10px 20px 20px;
    font-size: 14px;
  }
}
</style>
<style scoped>
.openBtn {
  position: absolute;
  height: 50px;
  width: 50px;
  font-size: 20px;
  right: 24%;
  top: 45%;
  transform: rotate(180deg);
}

.closeBtn {
  position: absolute;
  height: 50px;
  width: 50px;
  font-size: 20px;
  right: 0;
  top: 45%;
  transform: rotate(180deg);
}

::v-deep .el-drawer__wrapper {
  height: 100%;
  width: 24%;
  left: 76%;
  z-index: 1000 !important;
}

.el-popover.popoverStyle {
  z-index: 1000 !important;
}

::v-deep .el-drawer__body {
  background-color: #050F26;
  box-shadow: 5px 0 30px 0 rgba(41, 155, 255, .1) inset,
  10px 0 30px 0 rgba(41, 155, 255, 0.08) inset,
  15px 0 30px 0 rgba(41, 155, 255, 0.05) inset,
  20px 0 30px 0 rgba(41, 155, 255, 0.01) inset;
}
</style>
